import styled from 'styled-components';

const ListMobilStyle = styled.div`
h2 {
  padding: 5% 0;
}
  .listbox {
    margin: 2em 0;
    h3 {
      margin-top: 0.5em;
    }
  }
`;

export default ListMobilStyle;
